import type {
  PlaceCardGuest,
  CardProjectPlaceCardDetailView,
  CardProjectPlaceCardDetailGuestCreateRequest,
  CardProjectPlaceCardDetailGuestUpdateRequest,
} from '@zola/svc-web-api-ts-client';
import { AppThunk } from 'reducers/index';
import {
  GuestEdit,
  GuestSortBy,
  PlacecardGuestListAction,
  REQUEST_PLACECARD_GUEST_LIST,
  RECEIVE_PLACECARD_GUEST_LIST,
  SET_PLACECARD_GUEST_LIST_EDIT,
  SET_PLACECARD_GUEST_LIST_SORT_BY,
  SET_PLACECARD_GUEST_LIST_PREVIEW_GUEST,
} from 'cards/reducers/placecardGuestList/types';
import {
  fetchPlacecardGuestList as fetchPlacecardGuestListApi,
  createGuest as createGuestApi,
  updateGuest as updateGuestApi,
  deleteGuest as deleteGuestApi,
} from 'cards/util/placecardGuestList';

export const requestPlacecardGuestList = (): PlacecardGuestListAction => ({
  type: REQUEST_PLACECARD_GUEST_LIST,
});

export const receivePlacecardGuestList = (
  payload?: CardProjectPlaceCardDetailView
): PlacecardGuestListAction => ({
  type: RECEIVE_PLACECARD_GUEST_LIST,
  payload,
});

export const setEdit = (payload?: GuestEdit | null): PlacecardGuestListAction => ({
  type: SET_PLACECARD_GUEST_LIST_EDIT,
  payload,
});

export const setSortBy = (payload?: GuestSortBy | null): PlacecardGuestListAction => ({
  type: SET_PLACECARD_GUEST_LIST_SORT_BY,
  payload,
});

export const setPreviewGuest = (payload?: string | null): PlacecardGuestListAction => ({
  type: SET_PLACECARD_GUEST_LIST_PREVIEW_GUEST,
  payload,
});

export function fetchPlacecardGuestList({
  projectUuid,
}: {
  projectUuid: string;
}): AppThunk<Promise<CardProjectPlaceCardDetailView | null>> {
  return dispatch => {
    dispatch(requestPlacecardGuestList());
    return fetchPlacecardGuestListApi({ projectUuid })
      .then(guestList => {
        dispatch(receivePlacecardGuestList(guestList));
        return guestList;
      })
      .catch(() => null);
  };
}

export function createGuest({
  projectUuid,
  request,
}: {
  projectUuid: string;
  request: CardProjectPlaceCardDetailGuestCreateRequest;
}): AppThunk<Promise<CardProjectPlaceCardDetailView>> {
  return dispatch => {
    return createGuestApi({ projectUuid, request })
      .then(data => {
        dispatch(receivePlacecardGuestList(data));
        return data;
      })
      .catch(e => {
        throw e;
      });
  };
}

export function updateGuest({
  projectUuid,
  request,
}: {
  projectUuid: string;
  request: CardProjectPlaceCardDetailGuestUpdateRequest;
}): AppThunk<Promise<CardProjectPlaceCardDetailView>> {
  return dispatch => {
    return updateGuestApi({ projectUuid, request })
      .then(data => {
        dispatch(receivePlacecardGuestList(data));
        return data;
      })
      .catch(e => {
        throw e;
      });
  };
}

export function deleteGuest({
  projectUuid,
  guest,
}: {
  projectUuid: string;
  guest: PlaceCardGuest;
}): AppThunk<Promise<CardProjectPlaceCardDetailView>> {
  return dispatch => {
    return deleteGuestApi({ projectUuid, guest })
      .then(data => {
        dispatch(receivePlacecardGuestList(data));
        dispatch(setEdit(null));
        return data;
      })
      .catch(e => {
        throw e;
      });
  };
}
